import { Product } from '../../types/Product';
import { AGE_RANGES } from './ageRanges';

export const generateBabyMenuPrompt = (
  products: Product[],
  ageRange: string,
  menuName: string
): string => {
  const ageInfo = AGE_RANGES[ageRange as keyof typeof AGE_RANGES];
  
  const productContext = products.map(product => {
    return `- ${product.display_name}:
  * Categoría: ${product.category_name}
  * Marca: ${product.brand}
  * Descripción: ${product.description}`;
  }).join('\n');

  return `Como experto en nutrición infantil, genera una receta detallada y segura para "${menuName}".

IMPORTANTE - SEGURIDAD ALIMENTARIA INFANTIL:
- La receta es para bebés de ${ageInfo.label}
- Extremar precauciones con alergenos y texturas
- No añadir sal, azúcar ni condimentos fuertes
- Asegurar que todos los alimentos sean seguros y apropiados para la edad

Ingredientes disponibles:
${productContext}

Guía de edad (${ageInfo.label}):
${ageInfo.foods.map(food => `- ${food}`).join('\n')}

La receta debe incluir:

1. Advertencias de seguridad:
   - Alergenos potenciales a vigilar
   - Precauciones específicas para esta edad
   - Signos de intolerancia a observar

2. Preparación:
   - Limpieza e higiene necesaria
   - Utensilios recomendados
   - Textura apropiada para la edad

3. Elaboración paso a paso:
   - Instrucciones detalladas y claras
   - Tiempos de cocción específicos
   - Consistencia final deseada

4. Conservación y consumo:
   - Pautas de almacenamiento
   - Tiempo máximo de conservación
   - Temperatura de servido

5. Consejos adicionales:
   - Adaptaciones según desarrollo del bebé
   - Introducción gradual de nuevos sabores
   - Observaciones importantes

NOTA: Prioriza siempre la seguridad alimentaria y sigue las recomendaciones pediátricas actuales.`;
};